import { configureStore } from '@reduxjs/toolkit'
import { plataformaReducer } from './slices/plataformaSlice'
import { snackbarReducer } from './slices/snackbarSlice'
import { classificarReducer } from './slices/classificarSlice'
import { menuAjudaReducer } from './slices/menuAjudaSlice'

export const store = configureStore({
  reducer: {
    plataforma: plataformaReducer,
    snackbar: snackbarReducer,
    classificar: classificarReducer,
    menuAjuda: menuAjudaReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
